// src/components/FabricanteDashboard.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  CircularProgress,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { useNavigate } from 'react-router-dom';

import {
  StyledMainContainer,
  StyledHeaderWrapper,
  StyledPageTitle,
  StyledTableContainer,
  StyledTableHeaderCell,
  StyledNoUsersCell,
  StyledActionsBar
} from './StyleComponents';

import TipoRutinaCreate from './TipoRutinaCreate';
import Header from './Header';
import api from './api';

function TipoRutinaDashboard() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [openTipoRutinaCreate, setOpenTipoRutinaCreate] = useState(false);
  const [selectedTipoRutina, setSelectedTipoRutina] = useState(null);
  const [tipoRutinas, setTipoRutinas] = useState([]);
  const [loading, setLoading] = useState(true);

   const fetchTipoRutinas = async () => {
  try {
     setLoading(true);
     const { data } = await api.get('/tipos_rutinas/?skip=0&limit=1000');
     setTipoRutinas(data);
   } catch (error) {
     console.error('Error al obtener los tipos rutinas:', error);
     setTipoRutinas([]);
   } finally {
     setLoading(false);
   }
 };

  useEffect(() => {
    fetchTipoRutinas();
  }, []);

  const filteredTipoRutinas = tipoRutinas.filter(tiporutina => {
    const term = searchTerm.toLowerCase();
    
    const nombre = tiporutina.nombre?.toLowerCase() || '';
    // Asegúrate de que tiporutina.fabricante.nombre exista
    const fabricanteNombre = tiporutina.fabricante?.nombre?.toLowerCase() || '';
    const estatus = tiporutina.is_active ? 'activo' : 'inactivo'; // Usar is_active para estatus
    const periodicidad = tiporutina.periodicidad?.toLowerCase() || ''; // Convertir periodicidad a minúsculas

    return (
      nombre.includes(term) ||
      fabricanteNombre.includes(term) ||
      estatus.includes(term) || // Búsqueda por estatus
      periodicidad.includes(term) // Búsqueda por periodicidad
    );
  });

  const handleNavigateToRutinaDetail = (rutina) => {
    navigate(`/tipo_rutina_detail/${rutina}`)

  };

  const handleCreateTipoRutinaClick = () => {
    setSelectedTipoRutina(null);
    setOpenTipoRutinaCreate(true);
  };

  const handleCloseTipoRutinaCreate = () => {
    setOpenTipoRutinaCreate(false);
    setSelectedTipoRutina(null);
  };

  const handleSaveTipoRutina = () => {
  fetchTipoRutinas(); // 🔁 Siempre recarga lista completa tras guardar
  handleCloseTipoRutinaCreate();
};


  return (
    <StyledMainContainer>
      <Header />
      <StyledHeaderWrapper>
        <StyledPageTitle variant="h4" component="h1" gutterBottom>
          Tipos de Rutinas
        </StyledPageTitle>
      </StyledHeaderWrapper>

      <StyledActionsBar>
        <TextField
          label="Filtrar por nombre, fabricante, estatus"
          variant="outlined"
          fullWidth
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: (
              <IconButton>
                <SearchIcon />
              </IconButton>
            ),
          }}
        />
        <Button
          variant="contained"
          sx={{ whiteSpace: 'nowrap', minWidth: '150px' }}
          onClick={handleCreateTipoRutinaClick}
        >
          Crear Tipo de Rutina
        </Button>
      </StyledActionsBar>
          {loading ? (
   <Box display="flex" justifyContent="center" alignItems="center" height="200px">
     <CircularProgress />
   </Box>
 ) : (
      <StyledTableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableHeaderCell>Nombre</StyledTableHeaderCell>
              <StyledTableHeaderCell>Fabricante</StyledTableHeaderCell>
              <StyledTableHeaderCell>Estatus</StyledTableHeaderCell>
              <StyledTableHeaderCell>Periodicidad</StyledTableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTipoRutinas.length > 0 ? (
              filteredTipoRutinas.map((tiporutina) => (
                <TableRow key={tiporutina.id}>
                  <TableCell
                    sx={{ color: 'primary.main', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                    onClick={() => handleNavigateToRutinaDetail(tiporutina.id)}
                  >
                    {tiporutina.nombre}
                  </TableCell>
                  <TableCell>{tiporutina.fabricante?.nombre || '-'}</TableCell>
                  <TableCell>{tiporutina.is_active ? 'Activo' : 'Inactivo'}</TableCell>
                  <TableCell>{tiporutina.periodicidad }</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                
                <StyledNoUsersCell colSpan={4}>No se encontraron tipos de rutina.</StyledNoUsersCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
      )}

      <TipoRutinaCreate
        open={openTipoRutinaCreate}
        onClose={handleCloseTipoRutinaCreate}
        user={selectedTipoRutina}
        onSave={handleSaveTipoRutina}
      />
    </StyledMainContainer>
  );
}

export default TipoRutinaDashboard;
